<script>
import {mapActions} from "vuex";

export default {
  name: "OrderHistory",
  props: {
    /**
     * 排出事業者ID
     */
    emissionId: {
      type: Number,
      default: null
    },
    /**
     * 排出事業場コード
     */
    emissionLocationCode: {
      type: String,
      default: null
    },
    orderType: {
      type: String,
      default: "collection"
    },
  },
  watch: {
    emissionId: {
      handler(newValue, oldValue) {
        const currentValue = newValue || null;
        const previousValue = oldValue || null;
        if (currentValue && previousValue !== currentValue) {
          this.handleSearch();
        }
      },
      immediate: true
    },
    emissionLocationCode: {
      handler (newValue, oldValue) {
        const currentValue = newValue || null;
        const previousValue = oldValue || null;
        if (currentValue !== previousValue) {
          this.handleSearch();
        }
      },
    },
    immediate: true,
  },
  computed: {
    canSearch () {
      return this.emissionId;
    },
  },
  data() {
    return {
      /* キーワード */
      keyword: null,
      /* 回収履歴 */
      orders: [],
      /* テーブルヘッダ */
      tableHeader: [
        {
          value: "plan_date",
          text: "回収日\r\nマニ区分\r\n受注番号",
          width: "15%",
          filterable: false,
        },
        {
          value: "item_name",
          text: "取扱品目\r\n荷姿",
          width: "20%",
          filterable: true,
        },
        {
          value: "transport_route_name",
          text: "排出事業場\r\nルート\r\n処分事業場",
          width: "55%",
        },
        {
          value: "disposer_location_name",
          text: "",
          width: "0%",
        },
        {
          value: "actions",
          text: "",
          width: "10%",
          align: "center",
          filterable: false,
        }
      ],
    }
  },
  methods: {
    ...mapActions("DriverOrderHistory", {
      fetchHistories: "index",
      fetchHistory: "show"
    }),
    /**
     * 反映ボタン クリックイベント
     * @param item { Object }
     */
    reflectionButtonClickEvent (item) {
      this.fetchHistory({id: item.id}).then((content) => {
        this.$emit("reflect:order", content);
      })
    },
    /**
     * 検索前処理
     * 事業者IDがない場合は検索を行わない
     */
    handleSearch() {
      this.orders = []
      if (!this.canSearch) {
        return;
      }
      this.search();
    },
    /**
     * 検索処理
     */
    search () {
      const conditions = {
        emission_id: this.emissionId,
        emission_location_code: this.emissionLocationCode,
        keyword: this.keyword,
        order_type: this.orderType,
      }
      this.fetchHistories({ conditions: conditions }).then((content) => {
        this.orders = content.orders
      });
    },
  }
}
</script>

<template>
  <v-container v-if="canSearch">
    <v-card flat elevation="1">
      <v-card-title>
        <span class="v-label theme--light" style="font-size: 16px">直近の回収履歴&emsp;</span>
        <v-text-field
          v-model="keyword"
          append-icon="mdi-magnify"
          clearable
          dense
          hide-details="auto"
          outlined
          persistent-placeholder
          placeholder="品目・処分事業場・ルートから検索"
          style="font-size: 0.8rem"
        />
      </v-card-title>
      <v-data-table
        :headers="tableHeader"
        :items="orders"
        :items-per-page="-1"
        :search="keyword"
        disable-sort
        fixed-header
        height="250"
        hide-default-footer
      >
        <!-- 回収日, マニフェスト種別, 受注番号 -->
        <template v-slot:[`item.plan_date`]="{ item }">
          <div><small>{{ item.plan_date | date_format }}</small>&nbsp;</div>
          <div>
            <small>{{ item.manifest_type | short_manifest_type_label }}</small>
          </div>
          <div>
            <small>{{ item.order_no }}</small>
          </div>
        </template>
        <!-- /回収日, マニフェスト種別, 受注番号 -->

        <!-- 取扱品目, 荷姿 -->
        <template v-slot:[`item.item_name`]="{ item }">
          <div :title="item.item_name">
            <v-chip
              :title="item.item_name"
              color="#F0E6D0"
              drak
              label
              x-small
              class="chip-ellipsis"
            >
              <small>{{ item.item_name }}</small>
            </v-chip>
          </div>
          <div>
            <small>
              {{ item.packing_name }}&nbsp;全{{ item.total_items_count }}件
            </small>
          </div>
        </template>
        <!-- /取扱品目, 荷姿 -->

        <!-- 排出事業場, ルート, 処分事業場 -->
        <template v-slot:[`item.transport_route_name`]="{ item }">
          <div class="line-clamp one-clamp">
            <small>{{ item.supplier_location_name }}</small>
          </div>
          <div
            :title="`${item.transport_route_code}:${item.transport_route_name}`"
            class="line-clamp one-clamp"
          >
            <small>{{ item.transport_route_code }}:{{ item.transport_route_name }}</small>
          </div>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <div
                v-bind="attrs"
                v-on="on"
                class="line-clamp one-clamp"
              >
                <small>{{ item.disposer_location_name }}</small>
              </div>
            </template>
            <div><strong>{{ item.disposer_name }}</strong></div>
            <div>{{ item.disposer_location_name }}</div>
            <div>{{ item.disposer_location_address }}</div>
          </v-tooltip>
        </template>
        <template v-slot:[`item.disposer_location_name`]="{ item }">
          <span style="display: none">{{ item.disposer_location_name }}</span>
        </template>
        <!-- /排出事業場, ルート, 処分事業場 -->


        <template v-slot:[`item.actions`]="{ item }">
          <v-btn
            color="primary"
            small
            @click="reflectionButtonClickEvent(item)"
          >
            反映
          </v-btn>
        </template>

      </v-data-table>
    </v-card>
  </v-container>
</template>
